import { render } from "./cell_real_weight.vue?vue&type=template&id=c4f11206"
import script from "./cell_real_weight.vue?vue&type=script&lang=ts"
export * from "./cell_real_weight.vue?vue&type=script&lang=ts"

import "./cell_real_weight.vue?vue&type=style&index=0&id=c4f11206&lang=less"
script.render = render

export default script